<script setup lang="ts">
const props = withDefaults(defineProps<{
    src: string,
    fill?: string,
}>(), {
    fill: '#000000'
})
</script>

<template>
    <div class="svg-container">
        <img class="svg-img" :src="props.src" :style="{
            filter: 'drop-shadow(' + props.fill +' 0 1000px)'
        }">
    </div>
</template>

<style scoped lang="less">
.svg-container {
    overflow: hidden;

    .svg-img {
        width: 100%;
        height: 100%;
        transform: translateY(-1000px);
    }
}
</style>
